import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/axios';
import useProjectStore from '../stores/projectStore';

export function useAgentPipelines() {
  return useQuery({
    queryKey: ['agent-pipelines'],
    queryFn: async () => {
      const { data } = await api.get('/agent-pipelines', { skipProject: true });
      return data;
    },
  });
}

export function useSaveAgentPipeline() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...payload }) => {
      const cfg = { skipProject: true };
      const { data } = id
        ? await api.patch(`/agent-pipelines/${id}`, payload, cfg)
        : await api.post('/agent-pipelines', payload, cfg);
      return data.pipeline;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['agent-pipelines'] }),
  });
}

export function useDeleteAgentPipeline() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/agent-pipelines/${id}`, { skipProject: true }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['agent-pipelines'] }),
  });
}

export function useAssignProjectPipeline() {
  const fetchProjects = useProjectStore((s) => s.fetchProjects);
  return useMutation({
    mutationFn: ({ projectId, pipelineId }) =>
      api.post(
        '/agent-pipelines/assign-to-project',
        { project_id: projectId, pipeline_id: pipelineId },
        { skipProject: true },
      ),
    onSuccess: () => fetchProjects(),
  });
}
